import React, { useState, useEffect } from 'react'
import { map } from 'lodash';
import './role-modal-content'
import useAccessControlList from "Hooks/access-control.hook";
import {useSession} from "Hooks/index";

const RoleModalContent = () => {
  const { roleTypes } = useSession();


  const permission = useAccessControlList({
    roleTypes: roleTypes,
    resource: "User_Management",
  });

  const showRoleView = permission.rights.includes("ROLE_MODAL_ACCESS_VIEW");


  const roleAccessJSON = showRoleView ? [
    { role: 'Manager' }, { role: 'Supervisor' }, { role: 'Operational Staff' }
  ] :  [
    { role: 'Manager' }, { role: 'Supervisor' }
  ]

  return (
    <div className="role-modal-content">
      <h2>Role Access</h2>
      <div>
        <table>
          <thead>
            <tr className="header-row">
              <th className="header-col"></th>
              {map(roleAccessJSON, (roles) => {
                return (
                  <td>
                    {roles.role}
                  </td>
                )
              })
              }
            </tr>
          </thead>
          <tbody>
          {showRoleView && <tr>
              <th className="header-col">Customer Management</th>
              <td>
                <ul>
                  <li>Register Customer</li>
                  <li>Approve/Reject Customer</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>View list of customers</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>View list of customers</li>
                </ul>
              </td>
            </tr> }
          {showRoleView && <tr>
              <th className="header-col">Driver Management</th>
              <td>
                <ul>
                  <li>Register Driver</li>
                  <li>Approve/Reject Driver</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>View list of Driver</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>View list of Driver</li>
                </ul>
              </td>
            </tr> }
            <tr>
              <th className="header-col">User Management</th>
              <td>
                <ul>
                  <li>Register User</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>View list of User</li>
                </ul>
              </td>
              {showRoleView && <td>
                <ul>
                  <li>View list of User</li>
                </ul>
              </td>}
            </tr>
            <tr>
              <th className="header-col">Order Processing</th>
              <td>
                <ul>
                  <li>Create Order</li>
                  <li>View List of Orders</li>
                  <li>Accept/Reject/Flag Order</li>
                  <li>Assign Pick Up/ Drop Off Task</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>Create Order</li>
                  <li>View List of Orders</li>
                  <li>Accept/Reject/Flag Order</li>
                  <li>Assign Pick Up/ Drop Off Task</li>
                </ul>
              </td>
              {showRoleView && <ul>
                <li>View List of Orders</li>
              </ul> }
            </tr>
            <tr>
              <th className="header-col">Delivery Management</th>
              {showRoleView ? <td>
                <ul>
                  <li>Assign Driver for Pick Up & Last Mile</li>
                  <li>Sorting</li>
                  <li>Plan Train Journey</li>
                </ul>
              </td> : <td>
                <ul>
                <li>View List of Orders</li>
                </ul>
                </td> }
              {showRoleView ?  <td>
                <ul>
                  <li>Assign Driver for Pick Up & Last Mile</li>
                  <li>Sorting</li>
                  <li>Plan Train Journey</li>
                </ul>
              </td> : <td>
                <ul>
                  <li>View List of Orders</li>
                </ul>
              </td> }
              {showRoleView && <td>
                <ul>
                  <li>View List of Orders</li>
                </ul>
              </td> }
            </tr>
          {showRoleView && <tr>
              <th className="header-col">Mobile Application</th>
              <td>
                <ul>
                  <li>Receive Drop Off</li>
                  <li>Sorting</li>
                  <li>Load/Unload Trolley</li>
                  <li>Prepare/Complete Train Journey</li>
                  <li>Handover Parcel to Driver</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>Receive Drop Off</li>
                  <li>Sorting</li>
                  <li>Load/Unload Trolley</li>
                  <li>Prepare/Complete Train Journey</li>
                  <li>Handover Parcel to Driver</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>Receive Drop Off</li>
                  <li>Sorting</li>
                  <li>Load/Unload Trolley</li>
                  <li>Prepare/Complete Train Journey</li>
                  <li>Handover Parcel to Driver</li>
                </ul>
              </td>
            </tr> }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default RoleModalContent
